import { ModelBase, ModelState } from '../../core/model/model-base';
import { SubleaseRequestDecision, SubleaseRequestDecisionToString } from './const/enums';
import { Contact } from './contact';
import { Address } from '../../common/model/address';
import { LocalDate } from '../../core/model/local-date';

export class SubleaseRequest extends ModelBase {
  constructor() {
    super();
    this.subleaseeCurrentAddress = new Address();
    this.addressDuringSublease = new Address();
  }

  private _fromDate: LocalDate;
  private _toDate: LocalDate;
  private _created: Date;
  private _decisionDate: Date;
  contact: Contact;
  reason: string;
  subleaseeName: string;
  subleaseeCivicOrOrganizationNo: string;
  subleaseeEmail: string;
  subleaseePhone: string;
  subleaseeCurrentAddress: Address;
  addressDuringSublease: Address;
  decision: SubleaseRequestDecision;

  get created(): Date {
    return this._created;
  }
  set created(value: Date) {
    this._created = this.coerceDate(value);
  }
  get decisionDate(): Date {
    return this._decisionDate;
  }
  set decisionDate(value: Date) {
    this._decisionDate = this.coerceDate(value);
  }
  get decisionText(): string {
    return SubleaseRequestDecisionToString(this.decision);
  }
  get fromDate(): LocalDate {
    return this._fromDate;
  }
  set fromDate(value: LocalDate) {
    this._fromDate = LocalDate.fromDate(value);
  }

  state: ModelState;

  get toDate(): LocalDate {
    return this._toDate;
  }
  set toDate(value: LocalDate) {
    this._toDate = LocalDate.fromDate(value);
  }

  toJSON() {
    return {
      subleaseeName: this.subleaseeName,
      subleaseeCivicOrOrganizationNo: this.subleaseeCivicOrOrganizationNo,
      subleaseeEmail: this.subleaseeEmail,
      subleaseePhone: this.subleaseePhone,
      subleaseeCurrentAddress: this.subleaseeCurrentAddress,
      addressDuringSublease: this.addressDuringSublease,
      created: this.created,
      decisionDate: this.decisionDate,
      decision: this.decision,
      reason: this.reason,
      fromDate: this.fromDate,
      toDate: this.toDate,
    };
  }
}
